module.exports = __webpack_public_path__ + "static/media/virus.4d3a07a1.svg";